export default {
	message_arrived: "New message has arrived.",
	answer_arrived: "The answer has arrived.",
	notice_arrived: "A new notice has arrived.",
	deposit_rejected: "Your deposit request has been rejected.",
	deposit_approved: "Your deposit request has been approved.",
	withdrawal_approved: "Your withdrawal request has been approved.",
	withdrawal_denied: "Your withdrawal request has been denied.",
	balance_deducted: "Your balance has been deducted.",
	balance_credited: "Your balance has been credited.",
	point_deducted: "Points have been deducted.",
	point_credited: "Points have been credited.",
    money_increase: "Balance Increase",
	money_decrease: "Balance Deduction",
	point_increase: "Point Increase",
	point_decrease: "Point Deduction",
	loosing_increase: "Losing Money Increase",
	loosing_decrease: "Losing Money Deduction",
	point_exchange: "Point Exchange",
	to_money: "Convert to Balance",
    format_withdraw_request: "Withdrawal request from {param1}",
	format_approved_deposit: "Deposit request approved for {param1}",
	format_decreased_money_withreason: "{param1}'s balance has been deducted. Reason: {param2}",
	format_decrease_money_withreason: "{param1} ({param2}) had balance deducted. Reason: {param3}",
	format_increased_money_withreason: "Balance granted to {param1}. Reason: {param2}",
	format_increase_money_withreason: "{param1} ({param2}) received a balance grant. Reason: {param3}",
	format_decreased_point_withreason: "Points deducted from {param1}. Reason: {param2}",
	format_decrease_point_withreason: "{param1} ({param2}) had points deducted. Reason: {param3}",
	format_increased_point_withreason: "Points granted to {param1}. Reason: {param2}",
	format_increase_point_withreason: "{param1} ({param2}) received points. Reason: {param3}",
	format_increase_point_bybonsa_withreason: "HQ(HQ) granted points. Reason: Development team grant",
	format_decrease_point_bybonsa_withreason: "HQ(HQ) reclaimed points. Reason: Development team recall",
	format_bet_betgame: "{param1} placed a bet on bet game {param2}",
	format_bet_minigame: "{param1} placed a bet on minigame {param2}",
	format_win: "{param1}({param2}) bet won",
	format_bet: "{param1}({param2}) placed a bet",
	format_user_bet: "{param1} placed a bet on {param2}({param3})",
	format_user_detail_bet: "{param1} placed a bet on {param2} GAME {param3} {param4}",
	format_user_detail_refund: "{param1} received a refund for {param2} GAME {param3} {param4}",
	format_betcancel: "{param1}({param2}) bet cancelled",
	format_adjust: "{param1}({param2}) bet result adjusted",
	format_tie: "{param1}({param2}) bet tie",
	format_loss: "{param1}({param2}) bet lost",
	format_bonus: "{param1}({param2}) bonus",
	format_user_kplay_bet_rolling: "{param1} K-Play In-Play bet rolling on {param2}",
	format_kplay_loss_rolling: "{param1} K-Play In-Play loss rolling",
	format_manual_restore_decrease: "{param1} retrieved due to manual restoration processing",
	format_sport_rolling: "{param1} sports rolling",
	format_loss_rolling: "{param1} loss rolling",
	format_sport_refund: "{param1} sports refund",
	format_user_betgame_refund: "{param1} received a refund for BET GAME {param2}",
	format_decrease_event_bonus_dueto_deposit_cancel: "Deposit event bonus reclaimed due to deposit cancellation by {param1}",
	format_decrease_coupon_bonus_dueto_deposit_cancel: "Deposit coupon bonus reclaimed due to deposit cancellation by {param1}",
	format_decrease_firstdeposit_bonus_dueto_deposit_cancel: "First/Recurring deposit bonus reclaimed due to deposit cancellation by {param1}",
	format_decrease_deposit_money_dueto_deposit_cancel: "Deposit amount reclaimed due to deposit cancellation by {param1}",
	format_increase_point_dueto_register_firstdeposit_bonus: "{param1} received points equivalent to {param2}% for first deposit bonus upon registration",
	format_increase_point_dueto_today_firstdeposit_bonus: "{param1} received points equivalent to {param2}% for today's first deposit bonus",
	format_increase_point_dueto_every_firstdeposit_bonus: "{param1} received points equivalent to {param2}% for each deposit bonus",
	format_increase_point_dueto_event_depsit_bonus: "{param1} received points equivalent to {param2}% for event deposit bonus",
	format_increase_point_dueto_continuous_attendance: "{param2} received attendance bonus points for {param1} days",
	format_incraase_money_dueto_using_deposit_coupon: "{param1} used a deposit coupon. Details: Deposit Amount: {param2}, Coupon Bonus: {param3}%",
	format_cancel_withdrawal: "Withdrawal approval canceled by {param1}",
	format_deny_withdrawal: "Withdrawal request denied for {param1}",
	format_increase_point_dueto_deposit_bonus: "{param1} received deposit bonus points",
	format_manual_betting_cancel: "{param2} bet manually canceled by {param1} company",
	format_manual_betting_win: "{param2} bet manually marked as win by {param1} company",
	format_cancel_by_enterprise: "{param2} canceled by {param1} company",
	format_game_by_enterprise: "{param3} of {param2} by {param1} company",
	format_user_game: "{param1} {param2}",
	format_user_rolling: "{param1} {param2} rolling",
	format_user_loss_rolling: "{param1} {param2} loss rolling",
	format_user_coupon_usage: "{param1} used a coupon",
	format_user_lottery_win: "{param1} won the lottery",
	format_user_roulette_win: "{param1} won the roulette",
	format_bet_refunded: "The bet ({param1} P) has been refunded.",
	format_bet_lost: "The bet ({param1} P) has lost.",
	format_bet_win: "The bet ({param1} P) has won {param2} P."
};


// WEBPACK FOOTER //
// ./src/locales/en-US.js